import { buildModelManager } from "../builder.js";
const DefaultWhatsappTemplateSelection = {
  __typename: true,
  id: true,
  bodyParameters: true,
  buttonParameters: true,
  cards: true,
  copyCode: true,
  createdAt: true,
  customerId: true,
  expirationDate: true,
  expirationDelayInMinutes: true,
  expirationType: true,
  flowNodeId: true,
  headerParameters: true,
  isCancelable: true,
  isCopyCodeStatic: true,
  isEditing: true,
  limitedTimeOfferText: true,
  redirectionUrl2Id: true,
  redirectionUrlId: true,
  updatedAt: true,
  urlClicks: true,
  urlClicks2: true,
  whatsappTemplateName: true
};
const modelApiIdentifier = "whatsappTemplate";
const pluralModelApiIdentifier = "whatsappTemplates";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultWhatsappTemplateSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createWhatsappTemplate",
    operationReturnType: "CreateWhatsappTemplate",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      whatsappTemplate: { required: false, type: "CreateWhatsappTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkCreateWhatsappTemplates",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateWhatsappTemplatesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWhatsappTemplateSelection
  },
  {
    type: "action",
    operationName: "updateWhatsappTemplate",
    operationReturnType: "UpdateWhatsappTemplate",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      whatsappTemplate: { required: false, type: "UpdateWhatsappTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateWhatsappTemplates",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateWhatsappTemplatesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultWhatsappTemplateSelection
  },
  {
    type: "action",
    operationName: "deleteWhatsappTemplate",
    operationReturnType: "DeleteWhatsappTemplate",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteWhatsappTemplates",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertWhatsappTemplate",
    operationReturnType: "UpsertWhatsappTemplate",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      whatsappTemplate: { required: false, type: "UpsertWhatsappTemplateInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateWhatsappTemplateResult": { hasReturnType: false },
      "... on UpdateWhatsappTemplateResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultWhatsappTemplateSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertWhatsappTemplates",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertWhatsappTemplatesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultWhatsappTemplateSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "whatsappTemplateGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const WhatsappTemplateManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultWhatsappTemplateSelection,
  operations
);
export {
  DefaultWhatsappTemplateSelection,
  WhatsappTemplateManager
};
//# sourceMappingURL=WhatsappTemplate.js.map
